"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDefaultMix = exports.withDefault = void 0;
var withDefault = function (init, dfl) { return function (key) { var _a; return (_a = init[key]) !== null && _a !== void 0 ? _a : dfl[key]; }; };
exports.withDefault = withDefault;
var withDefaultMix = function (init, dfl) { return function (key) { var _a; return (_a = init[key]) !== null && _a !== void 0 ? _a : dfl[key]; }; };
exports.withDefaultMix = withDefaultMix;
